import {
  ResponsiveImageMedia,
  ResponsiveImageDimensions
} from '@/components/utils/ResponsiveImage/ResponsiveImage.models';
import { resizeImageUrl } from './resizeImageUrl';

export default (url: string, dimensions: ResponsiveImageDimensions): ResponsiveImageMedia => {
  return (Object.keys(dimensions) as Array<keyof ResponsiveImageDimensions>).reduce<ResponsiveImageMedia>(
    (media: ResponsiveImageMedia, key: keyof ResponsiveImageDimensions) => {
      media[key] = resizeImageUrl(url, dimensions[key]);

      return media;
    },
    { MQ1: '', MQ2: '', MQ3: '', MQ4: '', MQ5: '', MQ6: '' }
  );
};
